import { useGetQuery, useLazyGetQuery } from "slices/api";
import {
  ACCESS_APPLICATION,
  APPLICATION_DETAILS,
  APPLICATION_STATUS,
  APPROVAL_TRACKING,
  FIRE_SAFETY_APPLICATION,
} from "tagTypes";

export const useGetApplicationStatusHistoryQuery = () =>
  useGetQuery({
    endpoint: "/report/application-status-history",
    tags: [APPLICATION_STATUS],
  });

export const useLazyApplicationStatusHistoryQuery = () => {
  const [getApplicationStatus, data] = useLazyGetQuery();
  const applicationStatus = async (query = {}) =>
    await getApplicationStatus({
      endpoint: "/report/application-status-history",
      query,
      tags: [APPLICATION_STATUS],
    }).unwrap();
  return [applicationStatus, data];
};

export const useGetApplicationStatusHistoryByApplicationNumberQuery = (
  applicationId,
  isFireSafety = false
) =>
  useGetQuery({
    endpoint: isFireSafety
      ? `/building-information-status-tracking/${applicationId}/building-information-status-history`
      : `/report/application/${applicationId}/application-status-history`,
    tags: [APPLICATION_STATUS, FIRE_SAFETY_APPLICATION],
  });

export const useLazyApplicationStatusHistoryByApplicationNumberQuery = (
  applicationNumber
) => {
  const [getApplicationStatus, data] = useLazyGetQuery();
  const applicationStatus = async (query = {}) =>
    await getApplicationStatus({
      endpoint: `/report/application-status-history/${applicationNumber}`,
      query,
      tags: [APPLICATION_STATUS],
    }).unwrap();
  return [applicationStatus, data];
};

export const useGetApplicationStatusTrackingByApplicationIdQuery = (
  applicationId,
  query = {},
  isFireSafety = false,
  isUtilityTunnel = false
) =>
  useGetQuery(
    {
      endpoint: isFireSafety
        ? `/building-information/${applicationId}/approval-tracking`
        : isUtilityTunnel
        ? `/access-detail/${applicationId}/approval-tracking`
        : `/power/application/${applicationId}/approval-tracking`,
      query,
      tags: [
        APPLICATION_DETAILS,
        FIRE_SAFETY_APPLICATION,
        ACCESS_APPLICATION,
        APPROVAL_TRACKING,
      ],
    },
    true
  );
